export default {
  all: 'alle',
}
